import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../enums/QueryKey';
import { getAllUsers } from '../../services/user';

export function useHEMTUsers(withHemtUsers: boolean = false) {
    const { data, ...rest } = useQuery({
        queryKey: [QueryKey.HEMTUsers, { withHemtUsers }],
        queryFn: () => getAllUsers(withHemtUsers),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    return { data: data || [], ...rest };
}
